import type { JSX } from "react";
import { cn } from "./cn";

export type EngagementChannelColor = "blue" | "amber" | "purple" | "green";

export interface EngagementChannelChipProps {
  readonly label: string;
  readonly color?: EngagementChannelColor;
  readonly className?: string;
}

const colorMap: Readonly<Record<EngagementChannelColor, string>> = {
  blue: "bg-blue/20 text-blue",
  amber: "bg-amber/20 text-amber",
  purple: "bg-purple/20 text-purple",
  green: "bg-green/20 text-green",
};

/**
 * Small channel chip for engagement cards (Telegram, Email, Zoom, Slack, etc.).
 * Matches B1 design — colored background with matching text.
 */
export function EngagementChannelChip({
  label,
  color = "blue",
  className,
}: EngagementChannelChipProps): JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center px-2 py-[3px] rounded-md text-[10px] font-medium",
        colorMap[color],
        className,
      )}
    >
      {label}
    </span>
  );
}
